<template slot-scope="scope">
  <Modal v-model="model" title="添加成员" sticky reset-drag-position  @on-cancel="cancel" footer-hide draggable scrollable class="message_template_pop Internal_call" width="800">
    <div style="margin-bottom:10px;display: flex;" >
      <div style="background-color:#dae2fb;padding:10px 20px 0px 20px;height:33px;height:40px"><p style="color:#687084;">邀请人员:</p></div>
      <el-select v-model="transmitnumber" @input="checkNumber" multiple clearable allow-create filterable placeholder="" style="width:70%;margin-right:15px">
          <el-option
            v-for="item in opstsisons"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select>
      <Button type="primary" @click="invite()">邀请</Button>
    </div>
    <Tabs value="1" >
          <TabPane label="员工/客户" name="1">
            <div style="width:30%;margin-bottom:20px">
              <el-input placeholder="请输入工号/手机号码" v-model="agentNum" clearable>
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchEmployee()"></i>
              </el-input>
            </div>
            <div class="fixed_table" >
              <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
              <el-table  class="element_table" stripe ref="selection" :data="infoTableList" @selection-change="getSelectednumber">
                <el-table-column  v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
              </el-table>
            </div>
          </TabPane>
          <TabPane label="通讯录" name="2">
            <div style="width:30%;margin-bottom:20px">
              <el-input placeholder="请输入姓名/号码/备注" v-model="mailnumber" clearable>
                <i slot="suffix" class="el-input__icon el-icon-search" ></i>
              </el-input>
            </div>
            <div class="fixed_table">
              <Spin size="large" fix v-if="spinShowmail"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
              <el-table style="width: 100%" class="element_table" stripe ref="selection" :data="contentList.filter(data => !mailnumber || data.telephone.toLowerCase().includes(mailnumber.toLowerCase())|| data.userName.toLowerCase().includes(mailnumber.toLowerCase())||data.note.toLowerCase().includes(mailnumber.toLowerCase()))" @selection-change="getmailbnumber">
                <el-table-column v-for="(item,index) in mailfieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
              </el-table>
            </div>
          </TabPane>
    </Tabs>


  </Modal>
</template>

<script>
  // import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "Invitepage",
    props: {
      showInvitepage:Boolean,
    },
    data(){
      return {
        opstsisons: [],
        model:false,
         value: [],//显示邀请的值
        agentNum:'',//输入的值
        selection:"",
        spinShow:true,
        infoTableList:[],
        transmitnumber:[],
        oldTableList:[],
        definenumber:[],
        fieldList:[{key:'name','title':'姓名'}, {key:'number','title':'工号/号码'},{key:'status','title':'在线状态'},{type: 'selection', width: 50,'title':'全部添加'}],

        mailnumber:'',
        spinShowmail:true,
        contentList: [],
         mailfieldList: [
          {key: "userName", title: "姓名" },
          { key: "telephone", title: "号码" },
          { key: "note", title: "备注" },
          {type: 'selection', width: 50,'title':'全部添加'}
        ],
        searchCustomerFlag : false,
      }
    },
    methods:{
      checkNumber:function(value){
        if(value && value.length > 0 ){
          let newValue = value[value.length-1];
          let res = /^(\d+[,])*(\d+)$/;
          if(newValue.indexOf("(") != -1 && newValue.indexOf(")") != -1){
              return false;
          }
          if(!res.test(newValue)){
            this.$Message.info("格式错误,请重新输入");
            value.splice(value.length-1, 1);
            return false;
          }
        }
      },
      cancel:function(){
         this.$emit("closeInvitepage",'cancel');
      },
      getSelectednumber:function(selection){
       
        let combin="";
        for (let i=0;i<selection.length;i++){
              let choosenumber=selection[i].number;
              let choosename=selection[i].name;
              combin=choosenumber+"("+choosename+")";
              let index =this.transmitnumber.indexOf(combin);
              if(index==-1){
                this.transmitnumber.push(combin);
              }
        }
      },
      searchEmployee:function () {//点搜索后
          this.searchCustomerFlag = true;
          if(!this.agentNum){
            this.infoTableList=this.oldTableList;
            return false;
          }
          let re = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
          if(!re.test(this.agentNum)){
            this.$Message.info("格式错误,请重新输入");
            return false;
          }
          this.infoTableList=[];
          let item = this.oldTableList.find(item => {
              return item.number == this.agentNum;
          });
          let itempeopel = this.oldTableList.find(item => {
                let matchName = true; // 姓名 筛选
                let matchNum = true; // 号码 筛选
                matchName = item.name == this.agentNum;
                matchNum = item.number == this.agentNum;
                return matchName || matchNum;
          });
          if(itempeopel==undefined){
              this.repository();
          }else{
              this.infoTableList.push(itempeopel);
          }
      },
      repository:function(){
          let that=this;
          let param={
            journalType:"null",
            menuId:"null",
            agentStatus:"0",
            searchCustomer:this.agentNum
          };
          this.$http.post("popUp/getInternalCall.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              let list=res.data.obj;
              if(list.length==0){
                  that.$Message.info("暂无匹配信息");
                  return false;
              }
              let flag = true;
                for (let i=0;i<list.length;i++){
                 let param={
                  status:list[i].employeeOnLineState,
                  name:list[i].employeeName,
                  number:list[i].agentNumber
                  };
                  if(list[i].agentNumber == that.agentNum){
                    flag = false;
                  }
                  that.infoTableList.push(param);
                }
                if(flag){
                  let param={
                    status:'暂无',
                    name:'暂无',
                    number:that.agentNum
                  };
                  that.infoTableList.unshift(param);
                }
          });
      },
      initSearchAgent:function(){//表格里的数据
        this.spinShow=true;
        let that=this;
        let param={
          journalType:"null",
          menuId:"null",
          agentStatus:"0",
          searchCustomer:""
        };
        this.$http.post("popUp/getInternalCall.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          that.infoTableList=[];
          that.oldTableList=[];
          let list=res.data.obj;
          for (let i=0;i<list.length;i++){
            let param={
              status:list[i].employeeOnLineState,
              name:list[i].employeeName,
              number:list[i].agentNumber
            };
            that.infoTableList.push(param);
            that.oldTableList.push(param);
          }
        });
      },
      invite:function () {
          let that=this;
          let number=that.transmitnumber;
          if(number ==""){
            that.$Message.info("号码不能为空");
            return false;
          }
          for(let i=0;i<that.transmitnumber.length;i++){
            let source=that.transmitnumber[i];
            // 将（）以及括号内的内容替换
            let newValue = source.replace(/\([^\)]*\)/g,'').replace(/\（[^\)]*\）/g,'');
            let valueArr = newValue.split(",");
            for (let j=0;j<valueArr.length;j++){
              let param = valueArr[j];
              that.definenumber.push(param);
            }
          }
          that.$emit("closeInvitepage",'invitee',that.definenumber);
      },
      //通讯录相关
      initSearchmail:function () {
        let that=this;
        let param={
          journalType:"null",
          menuId:"null"
        };
        this.spinShowmail=true;
        this.$http.post("externalAddressBook/toIndex.json",param) .then(function (res) {
          let result=res.data;
          that.spinShowmail=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
        })
      },
      getmailbnumber:function(selection){
        let mailcombin="";
        for (let i=0;i<selection.length;i++){
              let choosenumber=selection[i].telephone;
              let choosename=selection[i].userName;
              mailcombin=choosenumber+"("+choosename+")";
              let index =this.transmitnumber.indexOf(mailcombin);
              if(index==-1){
                this.transmitnumber.push(mailcombin);
              }
        }
      },

    },
    computed:{
        search(){
          return this.agentNum;
        }
    },
    watch:{
      showInvitepage:function () {
        this.transmitnumber=[];
        this.definenumber=[];
        this.agentNum="";
        this.model=this.showInvitepage;
        let that = this;
        this.initSearchAgent();
        this.searchCustomerFlag = false;
        document.onkeydown = function(){
            let key = window.event.keyCode;
            if(key === 13){
              that.searchEmployee()
            }
        };

        this.mailnumber="";
        this.initSearchmail();

      },
      search(newValue,oldValue){
          if(newValue===""){
            this.searchCustomerFlag = false;
            this.infoTableList=this.oldTableList;
          }else{
            // 当不点击搜索是，才会过滤工号，点击搜索，不过滤
            if(this.searchCustomerFlag){
              return;
            }
            if(newValue){
              this.infoTableList = this.oldTableList.filter(item => item.number.indexOf(newValue) > -1);
            }else{
              this.infoTableList = this.oldTableList;
            }
          }
      }
    }


  }
</script>

<style lang="less">
.el-select-dropdown__empty{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/loginHeadMange/Invitepage.vue